import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ServiceOrderCellRendererParams } from './models/service-order-cell-renderer-params';
import { RouteConstants } from '../../../../../core/constants/routes';
import { Router } from '@angular/router';
import { ReturnRouteService } from '../../../../../core/services/navigation/return-route.service';

@Component({
    selector: 'app-service-order-cell-renderer',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './service-order-cell-renderer.component.html',
})
export class ServiceOrderCellRendererComponent
    implements ICellRendererAngularComp
{
    params!: ServiceOrderCellRendererParams;

    constructor(
        private readonly router: Router,
        private readonly returnRouteService: ReturnRouteService,
    ) {}

    agInit(params: ServiceOrderCellRendererParams): void {
        this.params = params as ServiceOrderCellRendererParams;
    }

    refresh(): boolean {
        return false;
    }

    navigate(): void {
        const link = this.getRouterLink();
        if (link) {
            this.returnRouteService.set(this.params.returnRoute ?? null);
            this.router.navigate([link]);
        }
    }

    getRouterLink(): string {
        return this.params.orderId
            ? RouteConstants.Order.getOrderSummaryRoute(this.params.orderId)
            : '';
    }
}
